import React from 'react';

import { StyledHeading } from './Heading.styles';
import { IHeadingProps } from './Heading.types';

const Heading = ({
  charSpacing,
  children,
  className,
  lg,
  md,
  sm,
  margin,
  tag,
  user,
  variant = 'primary',
}: IHeadingProps): JSX.Element => {
  return (
    <StyledHeading
      as={tag}
      charSpacing={charSpacing}
      className={className}
      lg={lg}
      md={md}
      sm={sm}
      margin={margin}
      user={user}
      variant={variant}
    >
      {children}
    </StyledHeading>
  );
};

export default Heading;
